// What each photo method can read. Ammonia and nitrite are colour tests
// too (feedback #79); the Hanna checkers are left off them, since the
// nitrite ULR checker shows ppb NO2-N, which would be saved as ppm nitrite.
export const PHOTO_PARAMS = {
  hanna: ['alk', 'calcium', 'magnesium', 'nitrate', 'phosphate'],
  strip: ['phosphate', 'nitrate', 'alk', 'calcium', 'ph', 'ammonia', 'nitrite'],
};

// Whether a photo method reads this built-in test. Other methods (manual,
// the refractometer) are not judged here.
export function photoMethodReads(kind, paramKey) {
  const list = PHOTO_PARAMS[kind];
  return !list || list.includes(paramKey);
}

// Whether any photo method reads this test.
export function photoReadable(paramKey) {
  return Object.values(PHOTO_PARAMS).some((list) => list.includes(paramKey));
}
